import { atom } from "jotai";

import CommonUtils from "~/utils/common-utils";

type SequentialLoadingState = {
  didomi: boolean;
  countryDetect: boolean;
  usablenet: boolean;
  GTM: boolean;
};

export const sequentialLoadingState = atom<SequentialLoadingState>({
  didomi: false,
  countryDetect: false,
  usablenet: false,
  GTM: false,
});

export const countryDetectReadyState = atom((get) => {
  const parentState = get(sequentialLoadingState);

  if (!parentState.didomi) {
    return false;
  }

  return true;
});

export const GTMReadyState = atom((get) => {
  const parentState = get(sequentialLoadingState);

  if (!parentState.didomi) {
    return false;
  }

  return true;
});

export const usableNetReadyState = atom((get) => {
  const parentState = get(sequentialLoadingState);

  if (!parentState.didomi) {
    return false;
  }

  if (CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_ENABLE_COUNTRY_DETECT) && !parentState.countryDetect) {
    return false;
  }

  return true;
});
